import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/app/current/src/app/[eventId]/buy-page/components/buyTicketSection/buyTicketSection.component.tsx");
